import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/base/services/base.service';
import { ProjetoProduto } from '../models/projeto-produto.model';
import { Observable } from 'rxjs';

@Injectable()
export class ProjetoRelatorioService extends BaseService<any> {

  constructor(public http: HttpClient) {
    super(http);
  }
  
  public getData(id:number, obj: any = null): Observable<any> {
    return this.http.post<any>(this.baseUrl + '/' + id, obj, { headers: this.headers });
  }

  public getPathModule(): string {
    return '/pre-projeto/relatorio';
  }
}
